(() => {
  'use strict';

  const root = document.documentElement;
  let updateQueued = false;

  const isVisible = (element) => {
    if (!element) return false;
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  };

  const updateInterfaceState = () => {
    updateQueued = false;

    const merchantFrame = document.getElementById('merchantwidgetiframe');
    if (merchantFrame && !merchantFrame.getAttribute('title')) {
      merchantFrame.setAttribute('title', 'Google customer reviews');
    }

    const consentSurfaces = document.querySelectorAll(
      '.shopify-pc__banner__dialog, #shopify-pc__banner, .shopify-pc__banner, .shopify-pc__prefs__dialog, #shopify-pc__prefs__dialog'
    );
    const cookieOpen = [...consentSurfaces].some(isVisible);
    root.classList.toggle('wmh-cookie-open', cookieOpen);

    const modalRoots = document.querySelectorAll('.react-responsive-modal-root');
    let popupOpen = false;
    modalRoots.forEach((modalRoot) => {
      const isEcomsend = Boolean(
        modalRoot.querySelector('.ecomsend__Modal__Container, [aria-labelledby="trustoo-popup-optIn-title"]')
      );
      modalRoot.classList.toggle('wmh-ecomsend-popup', isEcomsend);
      popupOpen = popupOpen || (isEcomsend && isVisible(modalRoot));
    });
    root.classList.toggle('wmh-popup-open', popupOpen);
  };

  const queueUpdate = () => {
    if (updateQueued) return;
    updateQueued = true;
    window.requestAnimationFrame(updateInterfaceState);
  };

  document.addEventListener('click', queueUpdate, true);
  document.addEventListener('keydown', queueUpdate, true);

  new MutationObserver(queueUpdate).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  queueUpdate();
})();
